import Loading from "layouts/components/Loading";
import { memo, useEffect, useState } from "react";
import { Badge, Button, Col, FormCheck, FormControl, FormSelect, Pagination, Row, Toast, ToastContainer } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../../utils/api";
import SourceItem from "./SourceItem";


const SourcesScreen = () => {

    const { p } = useParams();

    const [sources, setSources] = useState([]);

    const [profiles, setProfiles] = useState([]);

    const [search, setSearch] = useState('');

    const [filter, setFilter] = useState(1);

    const [toasts, setToasts] = useState([]);

    const [filtered, setFiltered] = useState([]);

    const [activeServer, setActiveServer] = useState(0);
    const [compact, setCompact] = useState(false);

    const [pagesCount, setPagesCount] = useState(1);
    const [page, setPage] = useState(p ? parseInt(p) : 1);
    const [pages, setPages] = useState([]);

    //const sockets = useWebSocket()

    const [statesCount, setStatesCount] = useState([
        { id: -1, name: 'Activos', count: 0 },
        { id: 1, name: 'Online', count: 0 },
        { id: 4, name: 'Fallidos', count: 0 },
        { id: 2, name: 'Backup', count: 0 },
        { id: 0, name: 'Inactivos', count: 0 }
    ]);


    const MemoizedSourceItem = memo(SourceItem);
    const navigate = useNavigate()

    useEffect(() => {
        console.log("sources: ", sources)
    }, [sources]);



    useEffect(() => {
        fetchData();
    }, []);

    const filterByServer = () => {
        if (activeServer === 0) return sources
        return sources.filter(item => item.server === activeServer);
    }

    const getFiltered = () => {
        return sources.filter(item => {

            if (search !== '') {
                if ((activeServer === 0 || activeServer === item.server)
                    && (item.name.toLowerCase().includes(search) || item.url.includes(search))) {
                    return true
                } else {
                    return false;
                }
            }

            if (filter === -1) {
                return item.status && (activeServer === 0 || activeServer === item.server)
            } else if (filter === -2) {
                return !item.status && (activeServer === 0 || activeServer === item.server)
            }

            return item.state === filter && (activeServer === 0 || activeServer === item.server)
        });
    }


    useEffect(() => {

        setStatesCount([
            { id: -1, name: 'Activos', count: sources.filter((item) => item.status).length },
            { id: 1, name: 'Online', count: sources.filter((item) => item.state === 1).length },
            { id: 4, name: 'Fallidos', count: sources.filter((item) => item.state === 4).length },
            { id: 2, name: 'Backup', count: sources.filter((item) => item.state === 2).length },
            { id: -2, name: 'Inactivos', count: sources.filter((item) => !item.status).length }
        ])


        const result = getFiltered()

        const min = (page - 1) * 30;
        const max = min + 30;

        const result2 = result.slice(min, max)
        setFiltered(result2)


        const pagesCount = Math.round(result.length / 30)
        generatePagination(page, pagesCount);

    }, [sources]);

    useEffect(() => {
        //const result = sources.filter(item => item.name.toLowerCase().includes(search.toLowerCase()) && (filter === -1 ? item.state !== 0 : item.state === filter));
        //const result = getFiltered()
        const byServer = filterByServer()

        setStatesCount([
            { id: -1, name: 'Activos', count: byServer.filter((item) => item.status).length },
            { id: 1, name: 'Online', count: byServer.filter((item) => item.state === 1).length },
            { id: 4, name: 'Fallidos', count: byServer.filter((item) => item.state === 4).length },
            { id: 2, name: 'Backup', count: byServer.filter((item) => item.state === 2).length },
            { id: -2, name: 'Inactivos', count: byServer.filter((item) => !item.status).length }
        ])

        const result1 = getFiltered()

        const min = (page - 1) * 30;
        const max = min + 30;
        const result2 = result1.slice(min, max)
        setFiltered(result2)

        const pagesCount = Math.round(result1.length / 30)
        generatePagination(page, pagesCount)
    }, [search, filter, page, activeServer]);



    /*
    useEffect(() => {

        if (sockets && sockets.length > 0) {

            sockets.forEach(socketObj => {
                if (socketObj.listenerReady) {
                    return
                }

                socketObj.listenerReady = true
                socketObj.socket.addEventListener('message', (event) => {


                    const json = JSON.parse(event.data)

                    if (json.action !== 'fail') {
                        //setToasts((prevMensajes) => [...prevMensajes, json]);
                    }

                
                    switch (json.action) {
                        case 'start':
                            updateSource(json.id, 1)
                            break;
                        case 'starting':
                            //updateSource(json.id, 3)
                            break;
                        case 'fail':
                            updateSource(json.id, 4)
                            break;
                        case 'stop':
                            updateSource(json.id, 0)
                            break;
                        default:
                            break;
                    }
                    
                });
            })
        }

    }, [sockets]);
*/



    const fetchData = async () => {
        try {


            const data1 = await Api.get('/profiles');
            setProfiles(data1)

            const merged = await Api.get('/allstreams');
            merged.sort((a, b) => a.name.localeCompare(b.name));
            setSources(merged);
            console.log(merged);

        } catch (error) {
            console.error('Error al obtener los datos:', error);
        }
    };

    const handleSelect = (event) => {
        setActiveServer(parseInt(event.target.value))
    }

    const handleSwitch = (event) => {
        setCompact(event.target.checked);
    }


    const generatePagination = (page, total) => {
        setPagesCount(total);

        let start = page - 5;
        let end = page + 5;

        if (start < 1) {

            end += (5 - page);
            start = 1;
        } else if (end > total) {

            end = total;
            start -= (5 - (total - page));
        }

        if (end > total) {
            end = total;
        }

        setPages(Array.from({ length: end - start + 1 }, (_, index) => start + index));
    };

    const changePage = (page) => {
        setPage(page);
        generatePagination(page, pagesCount);
    }


    /*
    const updateSource = (id, newValue) => {
        setSources(prevSources => {
            return prevSources.map(source => {
                if (source.id === id) {
                    // Reemplazar la propiedad en el objeto correspondiente
                    return { ...source, state: newValue };
                }
                return source; // Mantener los demás objetos sin cambios
            });
        });
    };
    */

    const ButtonCounter = ({ item }) => {

        const active = filter === item.id;
        let variant = 'info';
        switch (item.id) {
            case -2:
                variant = 'dark';
                break;
            case 1:
                variant = 'success';
                break;
            case 2:
                variant = 'warning';
                break;
            case 4:
                variant = 'danger';
                break;
            default:
                variant = 'info';
        }

        const handleClick = () => {
            setFilter(item.id)
        }

        return (
            <Button className="w-auto" style={{ minWidth: '120px' }} variant={active ? variant : 'outline-' + variant} onClick={handleClick}>
                {item.name} <Badge bg="dark" pill> {item.count}</Badge>
            </Button>
        )

    };

    const filterByEncoding = () => {
        const result = sources.filter(item =>
            item.outputs.some(output => output.profileId > 1 && output.status)
        );

        setFiltered(result);
    };

    if (sources == null || sources.length === 0) {
        return <Loading />
    }


    return (

        <>

            <ToastContainer position="bottom-end" className="m-3">
                {toasts.map((toast, index) => (
                    <Toast
                        key={index}
                        bg={toast.action === 'fail' ? 'danger' : 'primary'}
                        onClose={() => setToasts((prev) => prev.filter((_, i) => i !== index))}
                        delay={3000}
                        autohide>
                        <Toast.Header>
                            <strong className="me-auto">{toast.message}</strong>
                        </Toast.Header>
                        <Toast.Body>{toast.action === 'fail' ? 'Fallo al iniciar' : 'Iniciado'}</Toast.Body>
                    </Toast>
                ))}
            </ToastContainer>


            <h3>Lista de fuentes</h3>

            <Row className="mt-4 justify-content-between">
                <Col lg={5} md={7} sm={12}>
                    <Row>
                        <Col>
                            <FormSelect onChange={handleSelect}>
                                <option key={0} value={0}>Servidor: Todos</option>
                                {Api.servers.map((server) => (
                                    <option key={server.id} value={server.id}>Servidor: {server.name}</option>
                                ))}
                            </FormSelect>
                        </Col>
                        <Col>
                            <FormCheck type="switch">
                                <FormCheck.Input onChange={handleSwitch} />
                                <FormCheck.Label className="d-block align-items-start pt-1">Vista compacta</FormCheck.Label>
                            </FormCheck>
                        </Col>
                    </Row>
                </Col>

                <Col lg={4} md={6} sm={12}>
                    <FormControl className="form-control search-input" type="search" placeholder="Search" autoComplete="off" value={search} onChange={(e) => setSearch(e.target.value.toLowerCase())} />
                </Col>
            </Row>

            <Row className="mt-4">
                {statesCount.map((item, index) => (
                    <Col key={index} xs="auto" className="mt-2 mt-md-0">
                        <ButtonCounter item={item} />
                    </Col>
                ))}

                <Col xs="auto" className="mt-2 mt-md-0">
                    <Button onClick={filterByEncoding}>Ver solo encodings</Button>
                </Col>

                <Col xs="auto" className="mt-2 mt-md-0">
                    <Button onClick={() => navigate('/sources/new')}>Nueva Fuente</Button>
                </Col>
            </Row >


            <Row className="gx-3 gy-3 mt-3">
                {filtered.map((item, index) => (
                    <MemoizedSourceItem item={item} key={index} profiles={profiles} compact={compact} />
                ))}
            </Row>

            <Pagination className="mt-5">
                {page > 2 ? <Pagination.First onClick={() => { changePage(1) }} /> : ''}
                {page > 1 ? <Pagination.Prev onClick={() => { changePage(page - 1) }} /> : ''}
                {pages.map((number, index) => (
                    <Pagination.Item key={index} active={number === page} onClick={() => { changePage(number) }}>
                        {number}
                    </Pagination.Item>
                ))}
                {page < pagesCount ? <Pagination.Next onClick={() => { changePage(page + 1) }} /> : ''}
                {page < pagesCount ? <Pagination.Last onClick={() => { changePage(pagesCount) }} /> : ''}


            </Pagination>
        </>
    );
}

export default SourcesScreen;